import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Star } from "lucide-react";
import { approvedReviewsQuery } from "@/lib/verified-reviews.functions";
import { parseUnifiedSlug } from "@/lib/catalog.functions";

export function ReviewsSection({ slug, source }: { slug: string; source: "bokun" | "custom"; tourTitle: string }) {
  const { i18n } = useTranslation();
  const en = i18n.language.startsWith("en");
  const { key } = parseUnifiedSlug(slug);
  const { data } = useQuery({ ...approvedReviewsQuery(key), enabled: source === "bokun" && /^\d+$/.test(key) });
  if (!data?.count) return null;
  return <section id="reviews" className="mt-8 space-y-5 border-t border-border pt-5">
    <h2 className="font-display text-2xl">{en ? "Verified traveler reviews" : "Reseñas de viajeros verificados"}</h2>
    <p className="font-semibold">{data.avg.toFixed(1)} / 5 · {data.count} {en ? "reviews" : "reseñas"}</p>
    <div className="grid gap-4 sm:grid-cols-2">{data.reviews.map(r => <article key={r.id} className="rounded-lg border border-border bg-card p-4">
      <div className="flex items-center gap-1 text-gold" aria-label={`${r.rating} / 5`}>{Array.from({ length: r.rating }, (_, i) => <Star key={i} aria-hidden className="size-4 fill-current" />)}</div>
      <h3 className="mt-2 font-semibold">{r.title}</h3><p className="mt-2 whitespace-pre-line text-sm">{r.body}</p>
      <p className="mt-3 text-xs text-muted-foreground">{r.traveler_name} · {r.country} · {r.travel_date}</p>
      {r.owner_reply && <div className="mt-3 border-t border-border pt-3 text-sm"><p className="font-semibold">Mostrando México</p><p>{r.owner_reply}</p></div>}
    </article>)}</div>
  </section>;
}
